"use client";

import { Resource } from "@/db/schema";
import { useRouter, useSearchParams } from "next/navigation";
import * as React from "react";
import { useCallback, useEffect, useMemo } from "react";
import { SelectWithImage } from "../SelectWithImage";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  resources: Resource[];
}

export const ResourceSelectorDropdown: React.FC<Props> = ({
  resources,
  ...props
}) => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const selectedResource = useMemo(() => {
    const resourceFromParams = searchParams.get("selectedResource");
    return resourceFromParams &&
      resources.some((resource) => resource.id === resourceFromParams)
      ? resourceFromParams
      : resources[0]?.id;
  }, [searchParams, resources]);
  const setSelectedResource = useCallback(
    (id: string) => {
      const currentParams = new URLSearchParams(searchParams.toString());
      currentParams.set("selectedResource", id);
      const newSearchParams = currentParams.toString();
      const query = `?${newSearchParams}`;
      router.push(query);
    },
    [router, searchParams]
  );

  useEffect(() => {
    if (!selectedResource && resources.length > 0) {
      setSelectedResource(resources[0].id);
    }
  }, [selectedResource, resources, setSelectedResource]);

  return (
    <div {...props}>
      <SelectWithImage
        resources={resources}
        onSelect={(currentValue) => {
          setSelectedResource(currentValue);
        }}
        selected={selectedResource}
      />
    </div>
  );
};
